import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-industry-connect',
  templateUrl: './industry-connect.component.html',
  styleUrls: ['./industry-connect.component.scss']
})
export class IndustryConnectComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
